import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { AnalyticsService } from "@webapp/analytics/services/analytics.service";
import { KpiDetailsStateService } from "@webapp/kpis/components/kpi-details/services/kpi-details-state.service";
import { KpiTimeFilter } from "@webapp/kpis/models/kpis.models";

@Component({
  selector: "kpi-time-filters",
  templateUrl: "./kpi-time-filters.component.html",
  styleUrls: ["./kpi-time-filters.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiTimeFiltersComponent implements OnInit {
  @Input() public kpiId: string;
  public timeFilter$: Observable<KpiTimeFilter>;
  constructor(private kpiDetailsStateService: KpiDetailsStateService, private analyticsService: AnalyticsService) {}
  public ngOnInit(): void {
    this.timeFilter$ = this.kpiDetailsStateService.getTimeFilter$();
  }
  public onTimeFilterChange(timeFilter: KpiTimeFilter): void {
    this.kpiDetailsStateService.changeTimeFilter(timeFilter);
    this.analyticsService.track("KPI Chart Date Range Changed", { kpi_id: this.kpiId, time_filter: timeFilter });
  }
}
